// extracted by mini-css-extract-plugin
export default {"root":"TextArea_root__SXjpv","label":"TextArea_label__PxGBC","errorMessage":"TextArea_errorMessage__3zTmq"};